import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { RadioGroup, Radio } from '@guardian/source-react-components';
import { FieldLabel } from './FieldLabel';
export const RadioSelect = ({ formField, formData, setFormData, }) => (
// work around to enforce `display: flex;` to `RadioGroup`'s fieldset tag
// https://github.com/guardian/source/issues/580
_jsxs("div", Object.assign({ css: css `
			fieldset {
				display: flex;
			}
		` }, { children: [_jsx(FieldLabel, { formField: formField }, void 0), _jsx(RadioGroup, Object.assign({ name: formField.name, orientation: formField.options.length > 2 ? 'vertical' : 'horizontal' }, { children: formField.options.map((option, index) => {
                const isRadioChecked = formField.id in formData &&
                    formData[formField.id] === option.value;
                return (_jsx(Radio, { "data-testid": `form-field-${option.value}`, label: option.label, value: option.value, name: `${formField.id}`, checked: !!isRadioChecked, onChange: () => setFormData({
                        ...formData,
                        [formField.id]: option.value,
                    }) }, index));
            }) }), void 0)] }), void 0));
